import React, { useContext, useState } from 'react';
import axios from 'axios';
import { Form, Button, Alert, Modal, ButtonGroup } from 'react-bootstrap';
import Ocr from './Ocr'; 
import { AppContext } from '../AppContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL; 

const AddQuote = ({ bookId, pageCount, onSuccess }) => {
  const { quotesUpdated, setQuotesUpdated } = useContext(AppContext); 
  const [quoteText, setQuoteText] = useState('');
  const [quoteNotes, setQuoteNotes] = useState([{ text: '' }]);
  const [pageNo, setPageNo] = useState('');
  const [tags, setTags] = useState([]); 
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showOcrModal, setShowOcrModal] = useState(false);
  const [ocrTarget, setOcrTarget] = useState('quoteText'); 

  const handleQuoteTextChange = (e) => setQuoteText(e.target.value);
  const handlePageNoChange = (e) => setPageNo(e.target.value);

  const handleQuoteNoteChange = (index, e) => {
    const newQuoteNotes = [...quoteNotes];
    newQuoteNotes[index].text = e.target.value;
    setQuoteNotes(newQuoteNotes);
  };

  const addQuoteNote = () => setQuoteNotes([...quoteNotes, { text: '' }]);

  const removeQuoteNote = (index) => {
    const newQuoteNotes = quoteNotes.filter((_, i) => i !== index);
    setQuoteNotes(newQuoteNotes);
  };

  const handleTagsChange = (e) => {
    const newTags = e.target.value
      .split(',')
      .map(tag => tag.trim())
      .filter(tag => tag !== ''); 
    setTags(newTags); 
  };

  const handleOcrResults = (results) => {
    if (ocrTarget === 'quoteText') {
      setQuoteText(results);
    } else {
      const index = parseInt(ocrTarget, 10);
      if (index >= 0 && index < quoteNotes.length) {
        const newQuoteNotes = [...quoteNotes];
        newQuoteNotes[index].text = results;
        setQuoteNotes(newQuoteNotes);
      }
    }
    setShowOcrModal(false);
    setOcrTarget('quoteText'); 
  };

  const handleTextOcrClick = () => {
    setOcrTarget('quoteText');
    setShowOcrModal(true);
  };

  const handleNoteOcrClick = (index) => {
    setOcrTarget(index.toString());
    setShowOcrModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (pageNo > pageCount) {
      setError(`You exceeded the page count. Please enter ${pageCount} or a lower number.`);
      setTimeout(() => setError(''), 3000);
      return;
    }

    if (!quoteText.trim()) {
      setError("Please fill in the quote text.");
      setTimeout(() => setError(''), 3000);
      return;
    }

    setError('');
    try {
      const dataToSend = {
        bookId,
        text: quoteText,
        pageNo,
        quoteNotes: quoteNotes.filter(note => note.text.trim() !== ''),
        tags, 
      };

      await axios.post(`${BACKEND_URL}/api/quote/add`, dataToSend);
      setSuccess('Quote added successfully.');
      setError('');

      setQuotesUpdated(true); 
      if (onSuccess) onSuccess();
    } catch (error) {
      setError('An error occurred. Please try again.');
      setSuccess('');
    }
  };

  return (
    <div className="container mt-2">
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="pageNo">
          <Form.Label>Page Number</Form.Label>
          <Form.Control
            type='number'
            value={pageNo}
            onChange={handlePageNoChange}
            className='w-75'
            required 
          />
        </Form.Group>       

        <Form.Group controlId="quoteText">
          <Form.Label>Quote Text</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            value={quoteText}
            onChange={handleQuoteTextChange}
            className='w-75'
          />

          <div
          className="d-flex justify-content-end mt-2"
          style={{ paddingRight: "5.5rem" }} 
          >            
          <Button variant="secondary" className="btn-sm mt-2" onClick={handleTextOcrClick}>
            Fill with OCR
          </Button>

          </div>
        </Form.Group>

        <Form.Group controlId="quoteNotes">
          <Form.Label>Quote Notes (Optional)</Form.Label>
          {quoteNotes.map((note, index) => (
            <div key={index} className="d-flex mb-2 align-items-center">
              <Form.Control
                as="textarea"
                rows={2}
                value={note.text}
                onChange={(e) => handleQuoteNoteChange(index, e)}
                className="w-75"

              />
        <ButtonGroup style={{ gap: "1", marginRight: "0" }}>
                <Button 
                  variant="danger" 
                  className="ms-3" 
                  style={{
                  fontSize: "0.75rem",
                  padding: "1px 4px",
                  marginRight: "-1px" 
                  }} 
                  onClick={() => removeQuoteNote(index)}>
                Delete
              </Button>
              <Button 
              variant="secondary"  
              className="ms-2" 
              onClick={() => handleNoteOcrClick(index)}
              style={{
                  fontSize: "0.75rem",
                  padding: "1px 4px",
                  marginRight: "-1px" 
                  }} 
              >
                OCR
              </Button>
              </ButtonGroup>
            </div>
          ))}
          <div
          className="d-flex justify-content-end mt-2"
          style={{ paddingRight: "5.5rem" }} 
        >
          <Button variant="primary" className="btn-sm mb-2" onClick={addQuoteNote}>
            Add more notes
          </Button>
          </div>
        </Form.Group>

        <Form.Group controlId="tags">
          <Form.Label>Tags (separate with commas)</Form.Label>
          <Form.Control
            type="text"
            placeholder="Tags"
            onChange={handleTagsChange}
            className="w-75"
              />
        <div
          className="d-flex justify-content-end mt-2"
          style={{ paddingRight: "5.5rem" }}
        >        
      <Button className='btn-sm' variant="success" type="submit">
          Save
        </Button>
        </div> 
        </Form.Group>

          
      </Form>

      <Modal show={showOcrModal} onHide={() => setShowOcrModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>OCR Process</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Ocr onResultsSubmit={handleOcrResults} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowOcrModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddQuote;
